module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "opera-infoDetail"
  }, [_c('topNav', {
    attrs: {
      "title": _vm.$t('infoDetail_title'),
      "url": "/opera/info"
    }
  }), _vm._v(" "), (_vm.info.category == 1) ? _c('div', {
    staticClass: "infoDDateil"
  }, [_c('div', {
    staticClass: "envent"
  }, [_c('span', {
    staticClass: "eventName"
  }, [_vm._v(_vm._s(_vm.$t('infoDetail_eventName')) + ":")]), _c('span', [_vm._v(_vm._s(_vm.info.title))])]), _vm._v(" "), _c('ul', {
    staticClass: "evList clearfix"
  }, [_c('li', {
    staticClass: "infoLi"
  }, [_c('span', {
    staticClass: "infoName"
  }, [_vm._v(_vm._s(_vm.$t('infoDetail_noticeContent')) + ":")]), _c('span', {
    staticClass: "infoVal focus"
  }, [_vm._v(_vm._s(_vm.infoList.noticeContent))])]), _vm._v(" "), _c('li', {
    staticClass: "infoLi"
  }, [_c('span', {
    staticClass: "infoName"
  }, [_vm._v(_vm._s(_vm.$t('infoDetail_hotelNames')) + ":")]), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.infoList.hotelNames))])]), _vm._v(" "), _c('li', {
    staticClass: "infoLi"
  }, [_c('span', {
    staticClass: "infoName"
  }, [_vm._v(_vm._s(_vm.$t('infoDetail_dateCondition')) + ":")]), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm._f("fDate")(_vm.infoList.dateCondition)))])]), _vm._v(" "), _c('li', {
    staticClass: "infoLi"
  }, [_c('span', {
    staticClass: "infoName"
  }, [_vm._v(_vm._s(_vm.$t('infoDetail_checkTime')) + ":")]), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.infoList.checkTime))])]), _vm._v(" "), _c('li', {
    staticClass: "infoLi"
  }, [_c('span', {
    staticClass: "infoName"
  }, [_vm._v(_vm._s(_vm.$t('infoDetail_quota')) + ":")]), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.infoList.quota))])]), _vm._v(" "), _c('li', {
    staticClass: "infoLi "
  }, [_c('span', {
    staticClass: "infoName"
  }, [_vm._v(_vm._s(_vm.$t('infoDetail_quotaCondition')) + ":")]), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.infoList.quotaCondition))])]), _vm._v(" "), _c('li', {
    staticClass: "infoLi "
  }, [_c('span', {
    staticClass: "infoName"
  }, [_vm._v(_vm._s(_vm.$t('infoDetail_values')) + ":")]), _c('span', {
    staticClass: "infoVal focus"
  }, [_vm._v(_vm._s(_vm.infoList.values))])]), _vm._v(" "), _c('li', {
    staticClass: "infoLi"
  }, [_c('span', {
    staticClass: "infoName"
  }, [_vm._v(_vm._s(_vm.$t('infoDetail_noticeDatetime')) + ":")]), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.infoList.noticeDatetime))])])]), _vm._v(" "), _c('div', {
    staticClass: "infoClose",
    on: {
      "click": _vm.backlist
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('infoDetail_close')) + "\n    ")])]) : (_vm.info.category == 0) ? _c('div', {
    staticClass: "infoDDateil"
  }, [_c('div', {
    staticClass: "new"
  }, [_c('h1', [_vm._v(_vm._s(_vm.info.title))]), _vm._v(" "), _c('div', {
    staticClass: "sign"
  }, [_vm._v(_vm._s(_vm.infoList.sign))])]), _vm._v(" "), _c('div', {
    staticClass: "newContent",
    domProps: {
      "innerHTML": _vm._s(_vm.infoList.content)
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-168af5fe","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/operaPage/infoDetail.vue
// module id = 1738
// module chunks = 107